var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightCircle = function SvgArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.999 11.999c0-5.523 4.478-10 10.001-10s10 4.477 10 10-4.477 10-10 10.001S2 17.522 1.999 11.999m1.2 0a8.802 8.802 0 1 0 17.603 0 8.802 8.802 0 0 0-17.604 0m4.541 0a.5.5 0 0 1 .5-.499h6.314l-2.908-2.908a.5.5 0 0 1 .707-.706l3.76 3.76q.036.036.064.078l.007.013a.493.493 0 0 1 .012.503.5.5 0 0 1-.083.112l-3.76 3.761a.5.5 0 0 1-.707-.707l2.909-2.908H8.239a.5.5 0 0 1-.499-.499"
  })));
};
export default SvgArrowRightCircle;